import { CircularProgress } from "@mui/material";

export const Circular = () => (
  <div style={{ padding: "24px" }}>
    <CircularProgress size={75} />
  </div>
);
